export const normalizeStrain = (value = '') => value.trim().replace(/\s+/g, ' ').toLowerCase();
export const hasStrain = (value?: string) =>
  !!value?.trim() && !['unknown', 'n/a', 'none'].includes(normalizeStrain(value));
export const toProductTitleCase = (value: string) =>
  value
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase())
    .replace(/'\w/g, (match) => match.toLowerCase());

/** Match Embarc: strain headline, full product name underneath when different. */
export function productHeading(product: { name: string; strain?: string }) {
  const strain = hasStrain(product.strain) ? product.strain!.trim() : '';
  return {
    title: toProductTitleCase(strain || product.name || 'N/A'),
    subtitle:
      strain && normalizeStrain(product.name) !== normalizeStrain(strain)
        ? toProductTitleCase(product.name)
        : '',
  };
}

/** Conservative variant key when Catalyst has no structured strain metadata. */
export function productSizeFamily(name = ''): string {
  const withoutSize = name.replace(/\s+\d+(?:\.\d+)?\s*(?:milligrams?|mgs?|grams?|gms?|g)\s*$/i, '').trim();
  return withoutSize !== name.trim() ? normalizeStrain(withoutSize) : '';
}
